const visileColumns = [
  // {
  //   title: "Rec ID",
  //   field: "RecID",
  //   locked: false,
  //   filter: "text",
  //   width: "200",
  //   show: true,
  // },
  // {
  //   title: "Dept Code",
  //   field: "Dept_Code",
  //   locked: false,
  //   filter: "text",
  //   width: "140",
  //   show: true,
  // },
  {
    title: "Dept Div Code",
    field: "DeptDiv_Code",
    locked: false,
    filter: "text",
    width: "160",
    show: true,
  },
  {
    title: "Dept Name",
    field: "Dept_Name",
    locked: false,
    filter: "text",
    width: "220",
    show: true,
  },
  {
    title: "Dept Div Name",
    field: "DeptDiv_Name",
    locked: false,
    filter: "text",
    width: "220",
    show: true,
  },
  {
    title: "Employee No",
    field: "Employee_No",
    locked: false,
    filter: "numeric",
    width: "160",
    show: true,
  },
  // {
  //   title: "SSN",
  //   field: "SSN",
  //   locked: false,
  //   filter: "text",
  //   width: "200",
  //   show: true,
  // },
  {
    title: "Employee Name",
    field: "Employee_name",
    locked: false,
    filter: "text",
    width: "220",
    show: true,
  },
  {
    title: "Mailing Address 1",
    field: "Mailing_Address_1",
    locked: false,
    filter: "text",
    width: "220",
    show: true,
  },
  {
    title: "Mailing Address 2",
    field: "Mailing_Address_2",
    locked: false,
    filter: "text",
    width: "220",
    show: true,
  },
  {
    title: "City",
    field: "City",
    locked: false,
    filter: "text",
    width: "160",
    show: true,
  },
  {
    title: "State",
    field: "State",
    locked: false,
    filter: "text",
    width: "140",
    show: true,
  },
  {
    title: "Zip Code",
    field: "Zip_Code",
    locked: false,
    filter: "text",
    width: "140",
    show: true,
  },
  {
    title: "Next Increment Date",
    field: "Next_Increment_Date",
    locked: false,
    filter: "date",
    format: "MM/DD/yyyy",
    editor: "date",
    width: 200,
    show: true,
  },
  {
    title: "Retirement Code",
    field: "Retirement_Code",
    locked: false,
    filter: "text",
    width: "160",
    show: true,
  },
  {
    title: "Retirement Plan",
    field: "Retirement_Plan_Code",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Retirement Plan",
    field: "Retirement_Plan",
    locked: false,
    filter: "text",
    width: "260",
    show: true,
  },
  {
    title: "Over Payment",
    field: "Over_Payment",
    locked: false,
    filter: "numeric",
    width: "160",
    show: true,
  },
  {
    title: "Check Date",
    field: "Check_Date",
    locked: false,
    filter: "date",
    format: "MM/DD/yyyy",
    editor: "date",
    width: 180,
    show: true,
  },
  {
    title: "Check Sequence",
    field: "Check_Sequence",
    locked: false,
    filter: "numeric",
    width: "160",
    show: true,
  },
  {
    title: "Calendar Quarter",
    field: "Quarter_Check_Date_Calendar",
    locked: false,
    filter: "text",
    width: "220",
    show: true,
  },
  {
    title: "Calender Year",
    field: "Year_Check_Date_Calendar",
    locked: false,
    filter: "numeric",
    width: "200",
    show: true,
  },
  {
    title: "Fiscal Qurter",
    field: "Quarter_Check_Date_Fiscal",
    locked: false,
    filter: "text",
    width: "220",
    show: true,
  },
  {
    title: "Fiscal Year",
    field: "Year_Check_Date_Fiscal",
    locked: false,
    filter: "numeric",
    width: "200",
    show: true,
  },
  {
    title: "PPE",
    field: "Pay_Period_Ending_Date",
    locked: false,
    filter: "date",
    format: "MM/DD/yyyy",
    editor: "date",
    width: 220,
    show: true,
  },
  {
    title: "Quarter PPE",
    field: "Quarter_PPE_Calendar",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: " PPE Year",
    field: "Year_PPE_Calendar",
    locked: false,
    filter: "numeric",
    width: "200",
    show: true,
  },
  {
    title: "Quarter PPE Fiscal",
    field: "Quarter_PPE_Fiscal",
    locked: false,
    filter: "text",
    width: "200",
    show: true,
  },
  {
    title: "Year PPE Fiscal",
    field: "Year_PPE_Fiscal",
    locked: false,
    filter: "numeric",
    width: "200",
    show: true,
  },
  {
    title: "Gross Pay",
    field: "Gross_Pay",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "Adjusted Gross",
    field: "Adjusted_Gross",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "Guam Withholding Tax 2",
    field: "Guam_Withholding_Tax_Box2",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "FED Withholding Tax",
    field: "FED_Withholding_Tax",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "Soc Sec Gross",
    field: "Soc_Sec_Gross",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "Soc Sec Tax",
    field: "Soc_Sec_Tax",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "Medicare Gross",
    field: "Medicare_Gross",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "Medicare Tax",
    field: "Medicare_Tax",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "DC Plan",
    field: "DC_Plan",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "DB DB175 Plan",
    field: "DB_DB175_Plan",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "S457 Plan",
    field: "S457_Plan",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "Hawaii Gross",
    field: "Hawaii_Gross",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "Hawaii Tax",
    field: "Hawaii_Tax",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "California Gross",
    field: "California_Gross",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "California Tax",
    field: "California_Tax",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "Cafeteria Health Insurance",
    field: "Cafeteria_Health_Insurance",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "260",
    show: true,
  },
  {
    title: "Cafeteria Dental Insurance",
    field: "Cafeteria_Dental_Insurance",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "270",
    show: true,
  },
  {
    title: "Cafeteria Life Insurance",
    field: "Cafeteria_Life_Insurance",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "270",
    show: true,
  },
  {
    title: "Cafeteria Medical",
    field: "Cafeteria_Medical_care_Reimbursement",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "Cafeteria Day Care",
    field: "Cafeteria_Day_Care_Reimbursement",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "Cafeteria Health Savings Account",
    field: "Cafeteria_Health_Savings_Account",
    locked: false,
    filter: "numeric",
    width: "270",
    show: true,
  },
  {
    title: "Cafeteria Fee",
    field: "Cafeteria_fee",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "200",
    show: true,
  },
  {
    title: "Cafeteria Aflac Deduction",
    field: "Cafeteria_aflac_deduction",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "250",
    show: true,
  },
  {
    title: "Cafeteria Total Insurance",
    field: "Cafeteria_Total_Insurance_Sec_125_CP_Box14",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "250",
    show: true,
  },
  {
    title: "Health Govt Contribution",
    field: "Health_Govt_Contr",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "250",
    show: true,
  },
  {
    title: "Health Emp Contribution",
    field: "Health_Emp_Contr",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "250",
    show: true,
  },
  {
    title: "Dental Govt Contribution",
    field: "Dental_Govt_Contr",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "250",
    show: true,
  },
  {
    title: "Dental Emp Contribution",
    field: "Dental_Emp_Contr",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "250",
    show: true,
  },
  {
    title: "Health Dental Total",
    field: "Health_Dental_Total",
    className: "text-end",
    headerClassName: "number-align",
    format: "c2",
    locked: false,
    filter: "numeric",
    editor: "numeric",
   width: "250",
    show: true,
  }
];


export default visileColumns;
